"use client";

import { useEvmTransactFunction } from "../arch/evm/useEvmTransactFunction";
/**
 * Transaction helper function
 * @returns object:
 *  - transact: function that sends a transaction
 */
export const useTransact = () => {
  const evmTransact = useEvmTransactFunction();
  return evmTransact;
};